import { QueryClientProvider } from '@/_shared/context/ts-rest.js';
import { WidgetProvider } from '@/_shared/context/widget.js';
import { lightTheme } from '@/_shared/tools/theme.js';
import { router } from '@/app/_routes/index.js';
import { FluentProvider, Toaster } from '@fluentui/react-components';
import { RouterProvider } from '@tanstack/react-router';

export function App() {
    return (
        <FluentProvider data-fluent-provider theme={lightTheme}>
            <WidgetProvider>
                <QueryClientProvider>
                    <RouterProvider router={router} />
                </QueryClientProvider>
            </WidgetProvider>

            <Toaster toasterId="toast" />
        </FluentProvider>
    );
}
